/* ============================================================
   BeastBonBon - Product Page interactions
   - Dynamic variant system + variant-aware gallery
   - Multi-item ATC (main product + checked extras as separate
     line items, via /cart/add.js)
   - Accordion, pet name preview, mobile sticky bar
   Note: photo upload itself is owned by the Uploadly app block,
   not by this script.
   ============================================================ */
(function () {

  function cssEscape(s) {
    if (window.CSS && CSS.escape) return CSS.escape(s);
    return String(s).replace(/(["\\\[\]])/g, '\\$1');
  }

  function readProductData(root) {
    var script = root.querySelector('[data-bb-product-json]');
    if (!script) return null;
    try { return JSON.parse(script.textContent); } catch (e) { return null; }
  }

  function formatMoney(cents) {
    if (window.Shopify && Shopify.formatMoney) {
      var fmt = (window.theme && window.theme.moneyFormat) || '${{amount}}';
      return Shopify.formatMoney(cents, fmt);
    }
    return '$' + (cents / 100).toFixed(2);
  }

  function init(root) {
    if (!root || root.dataset.bbInit === 'true') return;
    root.dataset.bbInit = 'true';

    var data           = readProductData(root) || { options: [], variants: [] };
    var form           = root.querySelector('form[data-bb-product-form]') || root.querySelector('form.bb-form');
    var variantInput   = root.querySelector('[data-bb-variant-id]');
    var priceNowEls    = root.querySelectorAll('[data-bb-price-now]');
    var priceCmpEls    = root.querySelectorAll('[data-bb-price-compare]');
    var priceSaveEls   = root.querySelectorAll('[data-bb-price-save]');
    var qtyInput       = root.querySelector('[data-bb-qty-input]');
    var qtyValueEl     = root.querySelector('[data-bb-qty-value]');
    var atcButton      = root.querySelector('[data-bb-atc]');
    var atcLabel       = root.querySelector('[data-bb-atc-label]');
    var gallery        = document.querySelector('[data-bb-gallery]');
    var stickyBar      = document.querySelector('[data-bb-msticky]');
    var stickyPriceEl  = stickyBar ? stickyBar.querySelector('[data-bb-msticky-price]') : null;
    var stickyThumb    = stickyBar ? stickyBar.querySelector('[data-bb-msticky-thumb]') : null;
    var mPreview       = document.querySelector('[data-bb-mpreview]');
    var mPreviewImg    = mPreview ? mPreview.querySelector('[data-bb-mpreview-img]') : null;
    var mPreviewCap    = mPreview ? mPreview.querySelector('[data-bb-mpreview-cap]') : null;
    var mPreviewCapText = mPreviewCap ? mPreviewCap.textContent : '';
    var mPreviewCapTimer = null;
    var mZoom          = document.querySelector('[data-bb-mpreview-zoom]');
    var mZoomTrack     = mZoom ? mZoom.querySelector('[data-bb-mpreview-track]') : null;
    var mZoomDots      = mZoom ? mZoom.querySelector('[data-bb-mpreview-dots]') : null;
    var bbPreviewOpenRef = null;

    /* ---------- Build current selection map from hidden inputs ---------- */
    var currentSelections = {};
    data.options.forEach(function (optName) {
      var hidden = root.querySelector('[data-bb-as-variant="' + cssEscape(optName) + '"]');
      if (hidden) currentSelections[optName] = hidden.value;
    });

    /* ---------- Variant matching ---------- */
    function findVariant(values) {
      if (!data.variants || !data.variants.length) return null;
      var optionNames = data.options || [];
      return data.variants.find(function (v) {
        return optionNames.every(function (optName, i) {
          var picked = values[optName];
          if (picked == null || picked === '') return true;
          return String(v.options[i] || '').toLowerCase() === String(picked).toLowerCase();
        });
      }) || null;
    }

    function findFirstAvailableWith(optName, value) {
      if (!data.variants) return null;
      var idx = data.options.indexOf(optName);
      if (idx < 0) return null;
      return data.variants.find(function (v) {
        return v.available && String(v.options[idx] || '').toLowerCase() === String(value).toLowerCase();
      }) || null;
    }

    /* ---------- Sum of currently-checked extras (cents) ---------- */
    function extrasTotalCents() {
      var sum = 0;
      root.querySelectorAll('[data-bb-extra] input[data-bb-extra-cb]:checked').forEach(function (cb) {
        var extra = cb.closest('[data-bb-extra]');
        if (!extra) return;
        sum += parseInt(extra.getAttribute('data-bb-extra-price'), 10) || 0;
      });
      return sum;
    }

    /* ---------- Refresh the cart-side total
     * Main .bb-price stays as variant-only (so the product price reads clean).
     * The ATC button and the mobile sticky bar reflect what the customer will
     * actually pay, including checked extras.
     */
    function refreshTotal() {
      var v = findVariant(currentSelections);
      var base = v ? v.price : 0;
      var total = base + extrasTotalCents();
      var atcPrice = root.querySelector('.bb-atc__btn .price-now');
      if (atcPrice) atcPrice.textContent = formatMoney(total);
      if (stickyPriceEl) stickyPriceEl.textContent = formatMoney(total);
    }

    /* ---------- Update DOM after variant resolves ---------- */
    function applyVariant(variant) {
      if (!variant) return;

      if (variantInput) variantInput.value = variant.id;

      /* Main price element only (variant-only display). ATC + sticky get the
       * variant+extras total via refreshTotal() below. */
      root.querySelectorAll('.bb-price[data-bb-price-now]').forEach(function (el) {
        if (variant.price != null) el.textContent = formatMoney(variant.price);
      });

      if (priceCmpEls.length || priceSaveEls.length) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          priceCmpEls.forEach(function (el) {
            el.textContent = formatMoney(variant.compare_at_price);
            el.style.display = '';
          });
          priceSaveEls.forEach(function (el) {
            el.textContent = 'Save ' + formatMoney(variant.compare_at_price - variant.price).replace('.00', '');
            el.style.display = '';
          });
        } else {
          priceCmpEls.forEach(function (el) { el.style.display = 'none'; });
          priceSaveEls.forEach(function (el) { el.style.display = 'none'; });
        }
      }

      if (atcButton) {
        if (variant.available) {
          atcButton.removeAttribute('aria-disabled');
          if (atcLabel) atcLabel.textContent = atcButton.getAttribute('data-label-add') || 'Add to bag';
        } else {
          atcButton.setAttribute('aria-disabled', 'true');
          if (atcLabel) atcLabel.textContent = atcButton.getAttribute('data-label-soldout') || 'Sold out';
        }
      }

      /* URL update (no reload) */
      try {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      } catch (e) { /* ignore */ }

      updateOptionAvailability();
      updateOptionValuePrices();
      filterGalleryByStyle(variant);
      updateGallery(variant);
      refreshTotal();
    }

    /* ---------- Gallery Style filter ----------
       Show only the gallery tiles that belong to the selected Style
       (data-bb-styles contains "|<Style>|") plus shared tiles
       (data-bb-shared="1"). Thumbnails and dots are 1:1 with tiles by
       index, so they are hidden/shown in lockstep. */
    var bbStyleOptIdx = (function () {
      var opts = data.options || [];
      for (var i = 0; i < opts.length; i++) {
        if (String(opts[i]).toLowerCase().indexOf('style') >= 0) return i;
      }
      return -1; /* no Style option: filtering disabled */
    })();
    var bbLastStyle = null;
    var bbLastHeroId = null;
    function filterGalleryByStyle(variant) {
      if (!gallery || bbStyleOptIdx < 0) return;
      if (!variant || !variant.options) return;
      var styleVal = variant.options[bbStyleOptIdx];
      if (styleVal == null || styleVal === '') return;
      var token = '|' + styleVal + '|';

      var tiles  = gallery.querySelectorAll('.bb-gtile');
      if (tiles.length < 2) return; /* nothing to filter */
      var thumbs = gallery.querySelectorAll('[data-bb-gallery-thumbs] .bb-gallery__thumb');
      var dotsW  = document.querySelector('[data-bb-gallery-dots]');
      var dots   = dotsW ? dotsW.querySelectorAll('.bb-gallery__dot') : [];

      var anyVisible = false;
      tiles.forEach(function (tile, i) {
        var shared  = tile.getAttribute('data-bb-shared') === '1';
        var styles  = tile.getAttribute('data-bb-styles') || '';
        var visible = shared || styles.indexOf(token) >= 0;
        if (visible) anyVisible = true;
        tile.classList.toggle('bb-hide', !visible);
        if (thumbs[i]) thumbs[i].classList.toggle('bb-hide', !visible);
        if (dots[i])   dots[i].classList.toggle('bb-hide', !visible);
      });
      /* Safety: if a style had no matching tiles at all, show everything. */
      if (!anyVisible) {
        tiles.forEach(function (t, i) {
          t.classList.remove('bb-hide');
          if (thumbs[i]) thumbs[i].classList.remove('bb-hide');
          if (dots[i])   dots[i].classList.remove('bb-hide');
        });
      }

      /* Restore each tile image to its original src so a previous hero
         image-swap (stacked layout) never bleeds onto another tile. */
      tiles.forEach(function (t) {
        var img = t.querySelector('[data-bb-tile-media] img');
        if (!img) return;
        if (!img.getAttribute('data-bb-orig-src')) {
          img.setAttribute('data-bb-orig-src', img.getAttribute('src') || '');
        } else {
          var orig = img.getAttribute('data-bb-orig-src');
          if (orig && img.getAttribute('src') !== orig) img.setAttribute('src', orig);
        }
      });

      /* Hero = the selected variant's featured-media tile, so the main image
         recolors when the background color changes. The hero IS that real,
         single tile (no image-swap, no duplicate), pulled to the front with
         CSS order so it stays at the top of the stacked grid / mobile swipe.
         Falls back to the first visible tile if the featured media isn't a
         gallery tile. Both layouts: stacked uses .bb-gtile--main, swipe uses
         .is-stage-active. */
      var heroTile = null;
      if (variant.featured_media && variant.featured_media.id) {
        heroTile = gallery.querySelector('.bb-gtile[data-media-id="' + variant.featured_media.id + '"]');
      }
      if (!heroTile || heroTile.classList.contains('bb-hide')) {
        heroTile = gallery.querySelector('.bb-gtile:not(.bb-hide)');
      }
      if (heroTile) {
        tiles.forEach(function (t, i) {
          var isHero = (t === heroTile);
          t.classList.toggle('bb-gtile--main', isHero);
          t.classList.toggle('is-stage-active', isHero);
          t.style.order = isHero ? '-1' : '';
          if (dots[i]) dots[i].style.order = isHero ? '-1' : '';
        });
        /* Bring the hero into view on the mobile/stacked scroller when it changes. */
        var heroId = String(heroTile.getAttribute('data-media-id'));
        if (bbLastHeroId !== null && bbLastHeroId !== heroId) {
          try { gallery.scrollTo({ left: 0, behavior: 'auto' }); }
          catch (e) { gallery.scrollLeft = 0; }
        }
        bbLastHeroId = heroId;
      }
      bbLastStyle = styleVal;
    }

    function updateOptionValuePrices() {
      if (!data.variants || !data.variants.length) return;
      root.querySelectorAll('[data-bb-vopt-price]').forEach(function (priceEl) {
        var btn = priceEl.closest('[data-bb-vopt][data-val]');
        if (!btn) return;
        var optName = btn.getAttribute('data-bb-vopt');
        var value   = btn.getAttribute('data-val');
        var probe = Object.assign({}, currentSelections);
        probe[optName] = value;
        var match = data.variants.find(function (v) {
          return data.options.every(function (n, i) {
            var p = probe[n];
            if (p == null) return true;
            return String(v.options[i] || '').toLowerCase() === String(p).toLowerCase();
          });
        });
        if (match && match.price != null) {
          priceEl.textContent = formatMoney(match.price);
          priceEl.style.display = '';
        } else {
          priceEl.style.display = 'none';
        }
        /* Per-size Save badge + strikethrough compare-at, kept in sync with the matched variant. */
        var saveEl = btn.querySelector('[data-bb-vopt-save]');
        var cmpEl  = btn.querySelector('[data-bb-vopt-cmp]');
        var hasDiscount = match && match.compare_at_price && match.compare_at_price > match.price;
        if (cmpEl) {
          if (hasDiscount) { cmpEl.textContent = formatMoney(match.compare_at_price); cmpEl.hidden = false; }
          else { cmpEl.hidden = true; }
        }
        if (saveEl) {
          if (hasDiscount) { saveEl.textContent = 'Save ' + formatMoney(match.compare_at_price - match.price).replace('.00', ''); saveEl.hidden = false; }
          else { saveEl.hidden = true; }
        }
      });
    }

    function updateOptionAvailability() {
      if (!data.variants || !data.options) return;
      data.options.forEach(function (optName, optIdx) {
        var allValues = new Set();
        data.variants.forEach(function (v) { allValues.add(v.options[optIdx]); });
        allValues.forEach(function (val) {
          var probe = Object.assign({}, currentSelections);
          probe[optName] = val;
          var match = data.variants.find(function (v) {
            return data.options.every(function (n, i) {
              var p = probe[n];
              if (p == null) return true;
              return String(v.options[i] || '').toLowerCase() === String(p).toLowerCase();
            });
          });
          var available = match && match.available;
          var sel = '[data-bb-vopt="' + cssEscape(optName) + '"][data-val="' + cssEscape(val) + '"]';
          root.querySelectorAll(sel).forEach(function (el) {
            el.classList.toggle('is-unavailable', !available);
          });
          var selectEl = root.querySelector('select.bb-vopt-select[data-bb-vopt="' + cssEscape(optName) + '"]');
          if (selectEl) {
            Array.prototype.forEach.call(selectEl.options, function (o) {
              if (o.value === val) o.disabled = !available;
            });
          }
        });
      });
    }

    /* ---------- Gallery (variant-aware, no scroll) ---------- */
    function updateGallery(variant) {
      if (!gallery || !variant || !variant.featured_media) return;
      var fm = variant.featured_media;
      if (!fm.src) return;

      var isSwipeDesktop = gallery.classList.contains('bb-gallery--swipe') &&
                           window.matchMedia('(min-width: 981px)').matches;

      if (isSwipeDesktop) {
        /* Swipe layout: bring the variant's featured image onto the stage. */
        var allTiles = gallery.querySelectorAll('.bb-gtile');
        var target = fm.id ? gallery.querySelector('[data-media-id="' + fm.id + '"]') : null;
        if (target) {
          allTiles.forEach(function (t) { t.classList.remove('is-stage-active'); });
          target.classList.add('is-stage-active');
          var sidx = Array.prototype.indexOf.call(allTiles, target);
          var tw = gallery.querySelector('[data-bb-gallery-thumbs]');
          if (tw) {
            var tbtns = tw.querySelectorAll('.bb-gallery__thumb');
            tbtns.forEach(function (b, i) { b.classList.toggle('is-active', i === sidx); });
            if (tbtns[sidx] && tbtns[sidx].scrollIntoView) {
              try { tbtns[sidx].scrollIntoView({ behavior: 'smooth', inline: 'nearest', block: 'nearest' }); } catch (e) {}
            }
          }
        } else {
          /* No matching media tile: swap the current stage image directly. */
          var stage = gallery.querySelector('.bb-gtile.is-stage-active');
          var sImg = stage ? stage.querySelector('[data-bb-tile-media] img') : null;
          if (sImg) { sImg.src = fm.src; sImg.removeAttribute('srcset'); }
        }
      } else if (bbStyleOptIdx < 0) {
        /* Stacked/mobile hero swap. Skipped when the Style filter is active:
           there the hero is a real, visible gallery tile showing its own
           image, so swapping its src would clobber that photo and create a
           duplicate of another visible tile. */
        var mainTile  = gallery.querySelector('.bb-gtile--main');
        var mainMedia = mainTile ? mainTile.querySelector('[data-bb-tile-media]') : null;
        if (mainMedia) {
          var img = mainMedia.querySelector('img');
          if (img) {
            img.src = fm.src;
            img.removeAttribute('srcset');
          } else {
            mainMedia.style.backgroundImage = "url('" + fm.src + "')";
            mainMedia.style.backgroundSize = 'contain';
            mainMedia.style.backgroundPosition = 'center';
            mainMedia.style.backgroundRepeat = 'no-repeat';
          }
        }
      }

      if (fm.id) {
        var tile = gallery.querySelector('[data-media-id="' + fm.id + '"]');
        gallery.querySelectorAll('.bb-gtile').forEach(function (t) { t.classList.remove('is-active'); });
        if (tile) tile.classList.add('is-active');
      }

      if (stickyThumb && fm.thumb) {
        stickyThumb.style.backgroundImage = "url('" + fm.thumb + "')";
      }

      if (mPreviewImg && fm.src) {
        mPreviewImg.style.backgroundImage = "url('" + fm.src + "')";
        if (mPreview && mPreview.classList.contains('is-active')) {
          mPreview.classList.remove('is-pulse');
          void mPreview.offsetWidth;
          mPreview.classList.add('is-pulse');
        }
      }
    }

    /* ---------- Option click / change delegation ---------- */
    function pickOption(optName, value) {
      if (!optName || value == null) return;
      currentSelections[optName] = value;

      var hidden = root.querySelector('[data-bb-as-variant="' + cssEscape(optName) + '"]');
      if (hidden) hidden.value = value;

      root.querySelectorAll('[data-bb-vopt="' + cssEscape(optName) + '"]').forEach(function (el) {
        if (el.tagName === 'BUTTON' && el.hasAttribute('data-val')) {
          el.classList.toggle('is-on', String(el.getAttribute('data-val')) === String(value));
        } else if (el.tagName === 'SELECT') {
          el.value = value;
        }
      });

      var step = root.querySelector('.bb-step[data-bb-step-name="' + cssEscape(optName) + '"]');
      if (step) {
        var chosen = step.querySelector('[data-bb-chosen]');
        if (chosen) chosen.textContent = value;
      }

      var match = findVariant(currentSelections);
      if (!match) {
        var fallback = findFirstAvailableWith(optName, value);
        if (fallback) {
          data.options.forEach(function (n, i) {
            currentSelections[n] = fallback.options[i];
            var h = root.querySelector('[data-bb-as-variant="' + cssEscape(n) + '"]');
            if (h) h.value = fallback.options[i];
            root.querySelectorAll('[data-bb-vopt="' + cssEscape(n) + '"]').forEach(function (el) {
              if (el.tagName === 'BUTTON' && el.hasAttribute('data-val')) {
                el.classList.toggle('is-on', String(el.getAttribute('data-val')) === String(fallback.options[i]));
              } else if (el.tagName === 'SELECT') {
                el.value = fallback.options[i];
              }
            });
            var st = root.querySelector('.bb-step[data-bb-step-name="' + cssEscape(n) + '"]');
            if (st) {
              var c = st.querySelector('[data-bb-chosen]');
              if (c) c.textContent = fallback.options[i];
            }
          });
          match = fallback;
        }
      }

      applyVariant(match);
    }

    /* When a VISUAL variant type changes (Style or Color, both of which swap the
       preview image) and the floating preview chip is showing (gallery off-screen
       on mobile), auto-open the swipeable preview. Non-visual options (e.g. Size)
       keep the chip pulse only and do not open the popup. */
    function bbMaybeAutoPreview(optName) {
      if (!mPreview || !mZoom || !optName) return;
      if (!mPreview.classList.contains('is-active')) return;
      var name = String(optName).toLowerCase();
      var isVisual = name.indexOf('style') >= 0 || name.indexOf('color') >= 0 || name.indexOf('colour') >= 0;
      if (!isVisual) return;
      if (bbPreviewOpenRef) bbPreviewOpenRef();
    }

    root.addEventListener('click', function (e) {
      var btn = e.target.closest('button.bb-vopt[data-bb-vopt]');
      if (!btn) return;
      var optName = btn.getAttribute('data-bb-vopt');
      var value   = btn.getAttribute('data-val');
      pickOption(optName, value);
      bbMaybeAutoPreview(optName);
    });
    root.querySelectorAll('select.bb-vopt-select[data-bb-vopt]').forEach(function (sel) {
      sel.addEventListener('change', function () {
        pickOption(sel.getAttribute('data-bb-vopt'), sel.value);
        bbMaybeAutoPreview(sel.getAttribute('data-bb-vopt'));
      });
    });

    /* ---------- Pet name input ---------- */
    var nameInput = root.querySelector('.bb-name__input');
    if (nameInput) {
      nameInput.addEventListener('input', function (e) {
        var val = (e.target.value || '').trim();
        var preview = root.querySelector('[data-bb-name-preview]');
        if (preview) preview.textContent = val;
        var chosen = root.querySelector('.bb-step--name .bb-step__chosen, .bb-step[data-step="name"] .bb-step__chosen');
        if (chosen) chosen.textContent = val ? '"' + val + '"' : '';
        var step = root.querySelector('.bb-step--name, .bb-step[data-step="name"]');
        if (step) step.classList.toggle('is-done', val.length > 0);
      });
    }

    /* ---------- Extras (separate-line-item products) ---------- */
    function refreshExtrasChosen() {
      var picked = root.querySelectorAll('[data-bb-extra] input[data-bb-extra-cb]:checked');
      var chosen = root.querySelector('[data-bb-extras-chosen]') || root.querySelector('.bb-step--extras .bb-step__chosen');
      var step   = root.querySelector('.bb-step--extras, .bb-step[data-step="extras"]');
      if (chosen) {
        if (picked.length === 0) {
          chosen.textContent = chosen.getAttribute('data-default') || 'Optional';
        } else if (picked.length === 1) {
          var name = picked[0].closest('[data-bb-extra]').getAttribute('data-bb-extra-name');
          chosen.textContent = name || (picked.length + ' added');
        } else {
          chosen.textContent = picked.length + ' added';
        }
      }
      if (step) step.classList.toggle('is-done', picked.length > 0);
    }
    root.querySelectorAll('[data-bb-extra] input[data-bb-extra-cb]').forEach(function (cb) {
      cb.addEventListener('change', function () {
        var label = cb.closest('.bb-extra');
        if (label) label.classList.toggle('is-on', cb.checked);
        refreshExtrasChosen();
        refreshTotal();
      });
    });

    /* ---------- Quantity ---------- */
    var qtyMinus = root.querySelector('[data-bb-qty-minus]');
    var qtyPlus  = root.querySelector('[data-bb-qty-plus]');
    function setQty(n) { n = Math.max(1, Math.min(99, n)); if (qtyInput) qtyInput.value = n; if (qtyValueEl) qtyValueEl.textContent = n; }
    if (qtyMinus) qtyMinus.addEventListener('click', function () { setQty(parseInt((qtyInput && qtyInput.value) || '1', 10) - 1); });
    if (qtyPlus)  qtyPlus.addEventListener('click',  function () { setQty(parseInt((qtyInput && qtyInput.value) || '1', 10) + 1); });

    /* ---------- Mobile gallery pagination dots ---------- */
    (function initGalleryDots() {
      if (!gallery) return;
      var dotsWrap = document.querySelector('[data-bb-gallery-dots]');
      if (!dotsWrap) return;
      var tiles = gallery.querySelectorAll('.bb-gtile');
      var dots = dotsWrap.querySelectorAll('.bb-gallery__dot');
      if (!tiles.length || !dots.length) return;

      function setActive(i) {
        dots.forEach(function (d, idx) { d.classList.toggle('is-active', idx === i); });
      }

      if ('IntersectionObserver' in window) {
        var galleryIO = new IntersectionObserver(function (entries) {
          entries.forEach(function (en) {
            if (en.isIntersecting && en.intersectionRatio >= 0.6) {
              var idx = Array.prototype.indexOf.call(tiles, en.target);
              if (idx >= 0) setActive(idx);
            }
          });
        }, { root: gallery, threshold: [0.6] });
        tiles.forEach(function (t) { galleryIO.observe(t); });
      } else {
        gallery.addEventListener('scroll', function () {
          var i = Math.round(gallery.scrollLeft / gallery.clientWidth);
          setActive(Math.max(0, Math.min(tiles.length - 1, i)));
        }, { passive: true });
      }
    })();

    /* ---------- Desktop swipe gallery: main stage + thumbnail strip ---------- */
    (function initSwipeGallery() {
      if (!gallery || !gallery.classList.contains('bb-gallery--swipe')) return;
      var tiles = Array.prototype.slice.call(gallery.querySelectorAll('.bb-gtile'));
      if (tiles.length < 2) return;
      var thumbsStrip = gallery.querySelector('[data-bb-gallery-thumbs]');
      var thumbs = thumbsStrip ? Array.prototype.slice.call(thumbsStrip.querySelectorAll('.bb-gallery__thumb')) : [];

      function isDesktop() { return window.matchMedia('(min-width: 981px)').matches; }

      function isHidden(t) { return t && t.classList.contains('bb-hide'); }
      function showIndex(i, dir) {
        dir = (dir < 0) ? -1 : 1;
        var n = tiles.length;
        if (i < 0) i = n - 1;
        if (i >= n) i = 0;
        /* Skip tiles filtered out by the Style filter. */
        var guard = 0;
        while (isHidden(tiles[i]) && guard < n) {
          i += dir;
          if (i < 0) i = n - 1;
          if (i >= n) i = 0;
          guard++;
        }
        tiles.forEach(function (t, idx) { t.classList.toggle('is-stage-active', idx === i); });
        thumbs.forEach(function (t, idx) { t.classList.toggle('is-active', idx === i); });
        var activeThumb = thumbs[i];
        if (activeThumb && activeThumb.scrollIntoView) {
          try { activeThumb.scrollIntoView({ behavior: 'smooth', inline: 'nearest', block: 'nearest' }); } catch (e) {}
        }
      }

      thumbs.forEach(function (btn, idx) {
        btn.addEventListener('click', function () { if (isDesktop()) showIndex(idx); });
      });

      /* Thumbnail scroll arrows */
      gallery.querySelectorAll('[data-bb-thumbnav]').forEach(function (nav) {
        nav.addEventListener('click', function () {
          if (!isDesktop() || !thumbsStrip) return;
          var dir = parseInt(nav.getAttribute('data-bb-thumbnav'), 10) || 1;
          thumbsStrip.scrollBy({ left: dir * Math.round(thumbsStrip.clientWidth * 0.7), behavior: 'smooth' });
        });
      });

      /* Main stage: tap to advance, drag/swipe to change image */
      var startX = null, startY = null;
      function inStage(target) {
        if (target.closest('.bb-gallery__thumbswrap')) return false;
        if (target.closest('.bb-gtile__play')) return false;
        if (target.closest('.bb-gtile--video')) return false;
        var stage = gallery.querySelector('.bb-gtile.is-stage-active');
        return stage && stage.contains(target) ? stage : false;
      }
      gallery.addEventListener('pointerdown', function (e) {
        if (!isDesktop() || !inStage(e.target)) { startX = null; return; }
        startX = e.clientX; startY = e.clientY;
      });
      gallery.addEventListener('pointerup', function (e) {
        if (startX === null) return;
        var dx = e.clientX - startX, dy = e.clientY - startY;
        startX = null;
        var stage = gallery.querySelector('.bb-gtile.is-stage-active');
        if (!stage) return;
        var current = tiles.indexOf(stage);
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) {
          showIndex(current + (dx < 0 ? 1 : -1), dx < 0 ? 1 : -1);
        } else if (Math.abs(dx) < 8 && Math.abs(dy) < 8) {
          showIndex(current + 1, 1);
        }
      });
      gallery.addEventListener('pointercancel', function () { startX = null; });
    })();

    /* ---------- Gallery video play buttons ---------- */
    if (gallery) {
      gallery.querySelectorAll('.bb-gtile__play').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var tile = btn.closest('.bb-gtile');
          if (!tile) return;
          tile.classList.add('is-playing');
          var video = tile.querySelector('video');
          if (video) {
            video.muted = false;
            video.controls = true;
            var p = video.play();
            if (p && p.catch) { p.catch(function () {}); }
          }
        });
      });
    }

    /* ---------- Mobile sticky ATC ---------- */
    if (stickyBar && atcButton && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { stickyBar.classList.toggle('is-active', !en.isIntersecting); });
      }, { rootMargin: '-80px 0px 0px 0px' });
      io.observe(atcButton);
      var stickyGo = stickyBar.querySelector('[data-bb-msticky-go]');
      if (stickyGo) stickyGo.addEventListener('click', function () { atcButton.scrollIntoView({ behavior: 'smooth', block: 'center' }); });
    }

    /* ---------- Mobile variant preview: show once the gallery scrolls away ---------- */
    if (mPreview && gallery && 'IntersectionObserver' in window) {
      var mpIO = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { mPreview.classList.toggle('is-active', !en.isIntersecting); });
      }, { rootMargin: '-120px 0px 0px 0px' });
      mpIO.observe(gallery);
    }

    /* ---------- Mobile variant preview zoom (swipeable, Style-filtered) ----------
       Built from the gallery's currently visible tiles, so it mirrors the same
       Style-filtered set the gallery shows. No new images are requested. */
    if (mPreview && mZoom) {
      function bbCollectPreviewImgs() {
        var out = [];
        if (!gallery) return out;
        var tiles = Array.prototype.slice.call(gallery.querySelectorAll('.bb-gtile:not(.bb-hide)'));
        tiles.sort(function (a, b) {
          var ao = a.style.order === '' ? 0 : parseInt(a.style.order, 10);
          var bo = b.style.order === '' ? 0 : parseInt(b.style.order, 10);
          return (isNaN(ao) ? 0 : ao) - (isNaN(bo) ? 0 : bo);
        });
        tiles.forEach(function (t) {
          var img = t.querySelector('[data-bb-tile-media] img');
          var src = null;
          if (img) src = img.getAttribute('data-bb-orig-src') || img.currentSrc || img.getAttribute('src');
          if (!src) {
            var bm = t.querySelector('[data-bb-tile-media]');
            var bg = bm && bm.style.backgroundImage;
            if (bg && bg.indexOf('url(') === 0) src = bg.slice(4, -1).replace(/^["']|["']$/g, '');
          }
          if (src && out.indexOf(src) < 0) out.push(src);
        });
        return out;
      }
      function bbBuildPreviewSlides() {
        if (!mZoomTrack) return;
        var imgs = bbCollectPreviewImgs();
        if (!imgs.length && mPreviewImg) {
          var pb = mPreviewImg.style.backgroundImage;
          if (pb && pb.indexOf('url(') === 0) imgs.push(pb.slice(4, -1).replace(/^["']|["']$/g, ''));
        }
        mZoomTrack.innerHTML = '';
        if (mZoomDots) mZoomDots.innerHTML = '';
        imgs.forEach(function (src, i) {
          var slide = document.createElement('div');
          slide.className = 'bb-mpreview-zoom__slide';
          var im = document.createElement('img');
          im.src = src;
          im.alt = 'Your selection preview';
          slide.appendChild(im);
          mZoomTrack.appendChild(slide);
          if (mZoomDots) {
            var dot = document.createElement('span');
            dot.className = 'bb-mpreview-zoom__dot' + (i === 0 ? ' is-on' : '');
            mZoomDots.appendChild(dot);
          }
        });
      }
      function bbPreviewOpen() {
        bbBuildPreviewSlides();
        mZoom.classList.remove('is-collapsing');
        mZoom.classList.add('is-open');
        mZoom.setAttribute('aria-hidden', 'false');
        if (mZoomTrack) { try { mZoomTrack.scrollLeft = 0; } catch (e) {} }
      }
      function bbPreviewClose() {
        if (!mZoom.classList.contains('is-open')) return;
        mZoom.classList.add('is-collapsing');
        mZoom.setAttribute('aria-hidden', 'true');
        window.setTimeout(function () {
          mZoom.classList.remove('is-open');
          mZoom.classList.remove('is-collapsing');
          if (mPreview && mPreview.classList.contains('is-active')) {
            mPreview.classList.remove('is-pulse');
            void mPreview.offsetWidth;
            mPreview.classList.add('is-pulse');
          }
        }, 300);
      }
      bbPreviewOpenRef = bbPreviewOpen;
      mPreview.addEventListener('click', function () { bbPreviewOpen(); });
      mZoom.addEventListener('click', function (e) {
        if (e.target === mZoom || e.target.hasAttribute('data-bb-mpreview-close')) bbPreviewClose();
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && mZoom.classList.contains('is-open')) bbPreviewClose();
      });
      if (mZoomTrack && mZoomDots) {
        mZoomTrack.addEventListener('scroll', function () {
          var slideW = mZoomTrack.clientWidth * 0.78 + 14;
          var idx = slideW > 0 ? Math.round(mZoomTrack.scrollLeft / slideW) : 0;
          var ds = mZoomDots.children;
          for (var k = 0; k < ds.length; k++) ds[k].classList.toggle('is-on', k === idx);
        });
      }
    }

    /* ---------- Accordion ---------- */
    root.querySelectorAll('.bb-acc__item').forEach(function (it) {
      var head = it.querySelector('[data-bb-acc-toggle]') || it.querySelector('.bb-acc__head');
      if (!head) return;
      head.addEventListener('click', function () {
        var open = it.classList.toggle('is-open');
        head.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });

    /* ---------- Required-field validation (Pet Name, Pet Photo) ----------
       Per-template control: a step is required only if its block is present
       AND data-bb-required="true". Merchants toggle "Required to add to cart"
       in the Theme Editor on each step block. */
    function bbAnyValueIn(nodeList) {
      for (var i = 0; i < nodeList.length; i++) {
        if (String(nodeList[i].value || '').trim() !== '') return true;
      }
      return false;
    }

    function bbStepMissing(step) {
      if (!step || step.getAttribute('data-bb-required') !== 'true') return false;
      if (step.classList.contains('bb-step--name')) {
        var input = step.querySelector('input[data-bb-prop], .bb-name__input');
        return !input || String(input.value || '').trim() === '';
      }
      if (step.classList.contains('bb-step--upload')) {
        if (!form) return false;
        /* Property name the merchant has configured to match their upload app
           (default "Upload Pet Photo" for Uploadly). Plus legacy fallbacks. */
        var configuredName = step.getAttribute('data-bb-photo-prop') || 'Upload Pet Photo';
        var namesToCheck = [configuredName, 'Pet Photo URL', 'Pet Photo'];
        for (var n = 0; n < namesToCheck.length; n++) {
          var sel = 'input[name="properties[' + namesToCheck[n].replace(/"/g, '\\"') + ']"]';
          if (bbAnyValueIn(form.querySelectorAll(sel))) return false;
        }
        return true;
      }
      return false;
    }

    function bbClearErrors() {
      root.querySelectorAll('.bb-step.is-error').forEach(function (el) {
        el.classList.remove('is-error');
        var msg = el.querySelector('.bb-step__error');
        if (msg) msg.parentNode.removeChild(msg);
      });
    }

    function bbStartUploadAutoClear(step) {
      /* Upload apps set their hidden input via JS (not a typed event), so the
         input listener below cannot catch it. Instead, while the upload step
         is in error state, poll every 400ms; clear the error as soon as the
         photo is detected, then stop. Costs nothing when no error is visible. */
      if (step._bbUploadWatch) return;
      step._bbUploadWatch = setInterval(function () {
        if (!step.classList.contains('is-error') || !bbStepMissing(step)) {
          if (!bbStepMissing(step)) {
            step.classList.remove('is-error');
            var m = step.querySelector('.bb-step__error');
            if (m) m.parentNode.removeChild(m);
          }
          clearInterval(step._bbUploadWatch);
          step._bbUploadWatch = null;
        }
      }, 400);
    }

    function bbValidateRequired() {
      bbClearErrors();
      var steps = root.querySelectorAll('.bb-step--name, .bb-step--upload');
      var firstMissing = null;
      steps.forEach(function (step) {
        if (!bbStepMissing(step)) return;
        step.classList.add('is-error');
        var msg = document.createElement('div');
        msg.className = 'bb-step__error';
        msg.setAttribute('role', 'alert');
        msg.textContent = step.classList.contains('bb-step--upload')
          ? "Please upload your pet's photo."
          : "Please tell us your pet's name.";
        step.appendChild(msg);
        if (step.classList.contains('bb-step--upload')) bbStartUploadAutoClear(step);
        if (!firstMissing) firstMissing = step;
      });
      if (firstMissing) {
        try { firstMissing.scrollIntoView({ behavior: 'smooth', block: 'center' }); }
        catch (err) { firstMissing.scrollIntoView(); }
        return false;
      }
      return true;
    }

    /* Expose the validator so the additive Bundle & Save feature can reuse the exact
       same required-field check + highlight/scroll (no logic duplicated). Additive only. */
    if (root) root.__bbValidate = bbValidateRequired;

    /* Clear the name-step error as soon as the user starts typing. */
    root.addEventListener('input', function (e) {
      var step = e.target.closest && e.target.closest('.bb-step--name.is-error');
      if (!step) return;
      if (String(e.target.value || '').trim() !== '') {
        step.classList.remove('is-error');
        var msg = step.querySelector('.bb-step__error');
        if (msg) msg.parentNode.removeChild(msg);
      }
    });

    /* ---------- Multi-item ATC ---------- */
    if (form && atcButton) {
      form.addEventListener('submit', function (e) {
        if (!bbValidateRequired()) { e.preventDefault(); return; }

        /* If an upload app (Uploadly, etc.) created its own filled hidden input
           with the same name as our pre-rendered placeholder, disable the empty
           placeholders so they cannot override the real value on form submit. */
        form.querySelectorAll(
          'input[name="properties[Pet Photo URL]"], input[name="properties[Pet Photo]"]'
        ).forEach(function (el) {
          if (String(el.value || '').trim() === '') el.disabled = true;
        });

        var pickedExtras = root.querySelectorAll('[data-bb-extra] input[data-bb-extra-cb]:checked');
        var hasDrawer = !!document.querySelector('cart-drawer-component');

        /* If cart is set to "page" mode (no drawer on page) AND no extras, let the
           native form submission redirect to /cart. */
        if (pickedExtras.length === 0 && !hasDrawer) return;

        e.preventDefault();
        if (atcButton.getAttribute('aria-disabled') === 'true') return;
        atcButton.setAttribute('aria-busy', 'true');
        atcButton.disabled = true;

        var mainQty = Math.max(1, parseInt((qtyInput && qtyInput.value) || '1', 10));
        var mainId  = variantInput ? parseInt(variantInput.value, 10) : null;
        if (!mainId) {
          atcButton.removeAttribute('aria-busy');
          atcButton.disabled = false;
          return;
        }

        var props = {};
        var fd = new FormData(form);
        fd.forEach(function (value, key) {
          var m = key.match(/^properties\[(.+)\]$/);
          if (!m) return;
          if (typeof value === 'string') {
            if (value.length === 0) return;
            props[m[1]] = value;
          }
        });

        var items = [{ id: mainId, quantity: mainQty }];
        if (Object.keys(props).length > 0) items[0].properties = props;

        pickedExtras.forEach(function (cb) {
          var extra = cb.closest('[data-bb-extra]');
          if (!extra) return;
          var vid = parseInt(extra.getAttribute('data-bb-extra-variant'), 10);
          if (vid) items.push({ id: vid, quantity: mainQty });
        });

        /* Collect cart-items-component section IDs so Shopify returns rendered cart HTML
           in the /cart/add response. The cart-items-component inside the drawer listens
           for the cart:update event and re-renders itself using these sections. */
        var sectionIds = [];
        document.querySelectorAll('cart-items-component').forEach(function (el) {
          var sid = el.dataset && el.dataset.sectionId;
          if (sid && sectionIds.indexOf(sid) === -1) sectionIds.push(sid);
        });

        var payload = { items: items };
        if (sectionIds.length > 0) payload.sections = sectionIds.join(',');

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify(payload)
        })
        .then(function (r) {
          if (!r.ok) throw new Error('cart add failed: ' + r.status);
          return r.json();
        })
        .then(function (addResponse) {
          /* Fetch the full cart so we can pass item_count and the resource object
             to the cart:update event (the CartDrawerComponent reads
             event.detail.resource.item_count for its screen-reader announcement). */
          return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
            .then(function (rr) { return rr.json(); })
            .then(function (cart) { return { addResponse: addResponse, cart: cart }; });
        })
        .then(function (data) {
          if (hasDrawer) {
            /* Dispatch the CartAddEvent that Horizon's cart-drawer-component and
               cart-items-component listen for on document. Event name 'cart:update'
               matches ThemeEvents.cartUpdate in assets/events.js. The drawer's
               auto-open attribute (set when settings.auto_open_cart_drawer is true)
               causes it to slide open on this event. */
            var lastItem = (data.cart && data.cart.items && data.cart.items.length)
              ? data.cart.items[data.cart.items.length - 1]
              : null;
            var event = new CustomEvent('cart:update', {
              bubbles: true,
              detail: {
                resource: data.cart,
                sourceId: 'bb-product-form',
                data: {
                  source: 'bb-product-form',
                  itemCount: data.cart ? data.cart.item_count : undefined,
                  productId: lastItem ? String(lastItem.product_id) : undefined,
                  sections: data.addResponse ? data.addResponse.sections : undefined
                }
              }
            });
            document.dispatchEvent(event);
          } else {
            /* No drawer on this page (cart_type = page). Send the user to /cart. */
            window.location.href = '/cart';
          }
        })
        .catch(function (err) {
          console.error('BB ATC error:', err);
          window.location.href = '/cart';
        })
        .finally(function () {
          atcButton.removeAttribute('aria-busy');
          atcButton.disabled = false;
        });
      });
    }

    /* ---------- Initial sync ---------- */
    updateOptionAvailability();
    var initial = findVariant(currentSelections);
    if (initial) applyVariant(initial);
    refreshExtrasChosen();
    refreshTotal();
  }

  /* ---------- Before/After compare slider (unchanged) ---------- */
  function initCompare(cmp) {
    if (!cmp || cmp.dataset.bbInit === 'true') return;
    cmp.dataset.bbInit = 'true';
    var after  = cmp.querySelector('.bb-ba-compare__layer--after');
    var handle = cmp.querySelector('.bb-ba-compare__handle');
    if (!after || !handle) return;
    var dragging = false;
    function setPct(p) { p = Math.max(0, Math.min(100, p)); after.style.clipPath = 'inset(0 0 0 ' + p + '%)'; handle.style.left = p + '%'; }
    function fromEvent(e) { var r = cmp.getBoundingClientRect(); var x = (e.touches ? e.touches[0].clientX : e.clientX) - r.left; setPct((x / r.width) * 100); }
    cmp.addEventListener('mousedown', function (e) { dragging = true; fromEvent(e); });
    window.addEventListener('mouseup', function () { dragging = false; });
    window.addEventListener('mousemove', function (e) { if (dragging) fromEvent(e); });
    cmp.addEventListener('touchstart', function (e) { dragging = true; fromEvent(e); }, { passive: true });
    cmp.addEventListener('touchmove',  function (e) { if (dragging) fromEvent(e); }, { passive: true });
    cmp.addEventListener('touchend',   function () { dragging = false; });
    setPct(50);
  }

  /* ---------- Before/After slideshow (arrows + counter) ---------- */
  function initBaSlider(slider) {
    if (!slider || slider.dataset.bbInit === 'true') return;
    slider.dataset.bbInit = 'true';
    var track  = slider.querySelector('[data-bb-ba-track]');
    if (!track) return;
    var slides = slider.querySelectorAll('[data-bb-ba-slide]');
    var prev   = slider.querySelector('[data-bb-ba-prev]');
    var next   = slider.querySelector('[data-bb-ba-next]');
    var curEl  = slider.querySelector('[data-bb-ba-cur]');
    var capK   = slider.querySelector('[data-bb-ba-cap-k]');
    var capV   = slider.querySelector('[data-bb-ba-cap-v]');
    var total  = slides.length;
    var idx    = 0;
    function go(n) {
      if (n < 0) n = 0;
      if (n > total - 1) n = total - 1;
      idx = n;
      track.style.transform = 'translateX(' + (-100 * n) + '%)';
      if (curEl) curEl.textContent = n + 1;
      var slide = slides[n];
      if (slide) {
        if (capK) capK.textContent = slide.getAttribute('data-bb-ba-name') || '';
        if (capV) capV.textContent = slide.getAttribute('data-bb-ba-caption') || '';
      }
      if (prev) prev.disabled = (n === 0);
      if (next) next.disabled = (n === total - 1);
    }
    if (prev) prev.addEventListener('click', function () { go(idx - 1); });
    if (next) next.addEventListener('click', function () { go(idx + 1); });
    go(0);
  }

  function boot() {
    document.querySelectorAll('[data-bb-product-root]').forEach(init);
    document.querySelectorAll('[data-bb-compare]').forEach(initCompare);
    document.querySelectorAll('[data-bb-ba-slider]').forEach(initBaSlider);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
